import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0857cc00&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("c:\\xampp\\htdocs\\app.poojalab.com\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0857cc00')) {
      api.createRecord('0857cc00', component.options)
    } else {
      api.reload('0857cc00', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0857cc00&", function () {
      api.rerender('0857cc00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/configuration/task/index.vue"
export default component.exports